<template>
  <div id="question_view">
    <quiz-header />
    <pre v-if="false">{{
      {
        startAt,
        next: quizStore.nextQuestion(),
        nextRoute: quizStore.getRoute(quizStore.nextQuestion()),
      }
    }}</pre>
    <component
      v-if="currentQuestion"
      :is="questionTypes[currentQuestion.type]"
      :question="currentQuestion"
      :answer="
        quizStore.answers.find(
          (answer) => answer.question_id === currentQuestion.id
        )
      "
      v-model="choices"
      @nextQuestion="nextQuestion()"
    />
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useQuizStore } from "@/stores/quiz";
import QuizHeader from "@/components/QuizHeader.vue";
import QuestionQCM from "@/components/QuestionQCM.vue";
import QuestionQCU from "@/components/QuestionQCU.vue";
import QuestionQRS from "@/components/QuestionQRS.vue";
import QuestionQPO from "@/components/QuestionQPO.vue";
import QuestionQPA from "@/components/QuestionQPA.vue";
const quizStore = useQuizStore();
const route = useRoute();
const router = useRouter();

const questionTypes = {
  QCM: QuestionQCM,
  QCU: QuestionQCU,
  QRS: QuestionQRS,
  QPO: QuestionQPO,
  QPA: QuestionQPA,
};

const props = defineProps({
  segmentId: {
    type: Number,
    required: true,
  },
  questionId: {
    type: Number,
    required: true,
  },
});
quizStore.setStatus(props.segmentId, props.questionId);
quizStore.setCurrentRoute(route.name, route.params);

if (quizStore.startedAt === null) quizStore.setStartedAt(Date.now());

const currentQuestion = quizStore.currentQuestion();
const choices = ref([]);
const nextQuestion = () => {
  if (
    !choices.value ||
    (!choices.value.length && !Object.values(choices.value).length)
  )
    return;
  quizStore.setAnswer(choices.value, currentQuestion);
  const next = quizStore.nextQuestion();
  router.push(quizStore.getRoute(next));
};

onMounted(() => {
  setTimeout(function () {
    document
      .getElementById("quiz_block")
      .scrollIntoView({ behavior: "smooth" });
  }, 50);
});
</script>
